import type { Location } from 'history'
import { NavigationPrompt } from '@cbgms/base/navigation-prompt/NavigationPrompt'
import ConfirmNavigationModal from '@cbgms/components/layout/ConfirmNavigationModal'
import { BaseNavigationDialogContent } from './BaseNavigationDialogContent'

export enum BaseDialogVersion {
  SemanticUi = 'semantic_ui',
  MuiUi = 'mui_ui'
}

export enum ActionBeforeLogout {
  OrderUpdate = 'order_update',
  OrderDelete = 'order_delete'
}

interface Props {
  baseDialogVersion?: `${BaseDialogVersion}`
  name?: string
  when: (currentLocation: Location, nextLocation?: Location) => boolean
}

export function BaseNavigationConfirmation({ baseDialogVersion, name, when }: Props) {
  return (
    <NavigationPrompt
      name={name ?? 'base-navigation-confirmation'}
      component={!baseDialogVersion || baseDialogVersion === BaseDialogVersion.MuiUi ? BaseNavigationDialogContent : ConfirmNavigationModal}
      when={when}
    />
  )
}
